import { ExpenseAccrualPaymentStatusEnum } from "./payment-status-enum";

export const expenseAccrualPaymentStatusColors = {
  [ExpenseAccrualPaymentStatusEnum.UNPAID]: "default",
  [ExpenseAccrualPaymentStatusEnum.PARTIALLY_PAID]: "warning",
  [ExpenseAccrualPaymentStatusEnum.FULLY_PAID]: "success",
};
